import { useState, useEffect } from "react";
import { Configuration } from "src/types/configuration";

const useInitialConfiguration = (
  isLoaded: boolean,
  onInit: (config: Configuration) => void
) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const configurationHashEl = document.getElementById(
      "configuration-hash"
    ) as HTMLInputElement | null;

    if (!isInitialized && isLoaded && configurationHashEl) {
      // const hash = window.location.hash.split("#")[1];
      const hash = configurationHashEl.value;

      if (hash) {
        try {
          const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
          let json = hash;

          if (base64Regex.test(hash)) {
            json = atob(hash);
          }

          const parsedConfig = JSON.parse(json) as Configuration;

          onInit(parsedConfig);
        } catch (e) {
          console.error("Failed to parse configuration JSON:", e);
        }
      }

      setIsInitialized(true);
    }
  }, [isInitialized, onInit]);
};

export default useInitialConfiguration;
